import { render } from "./LogInstallUpdatesComponent.vue?vue&type=template&id=50d09558&scoped=true"
import script from "./LogInstallUpdatesComponent.vue?vue&type=script&lang=js"
export * from "./LogInstallUpdatesComponent.vue?vue&type=script&lang=js"

import "./LogInstallUpdatesComponent.vue?vue&type=style&index=0&id=50d09558&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d09558"]])

export default __exports__